<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF PHARMACY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">ABOUT US</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool05/1.jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">Pharmacy, as a discipline</h2>
                <p>ARNI School of Pharmacy stands as a pillar of excellence in pharmaceutical education, research, and
                    healthcare innovations. With a strong commitment to advancing the field of pharmacy, we empower
                    students to become professionally skilled workers who are dedicated to improving public health and
                    wellbeing. Through the course, students are well-prepared to meet and resolve the challenges of the
                    pharmaceutical industry and healthcare sector from drug development to clinical research and patient
                    care. The Bachelors of Science in Pharmacy from ARNI University explore meaningful careers in a
                    rapidly evolving field.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <p><b>Vision </b> - To be one of the leading names in educational institutions serving to pharmacy
                    industries,
                    research, and practice, contributing to the advancement of healthcare through innovative solutions,
                    ethical practices, and global impact.
                </p>
                <p><b>Mission </b> – Provide comprehensive academic programs and practical knowledge that collaborate
                    with
                    advanced pharmaceutical sciences. Train students to prioritize patient care and safety while
                    maintaining the work culture.
                </p>
                <h2>Master’s and Bachelors Degree in Pharmacy</h2>
                <p>Arni School of Pharmacy offers Bachelor in Pharmacy and Diploma Pharmacy courses, focusing on
                    providing high-quality education in pharmacy for students. The institution's experienced faculty,
                    modern facilities, and emphasis on practical learning ensure students receive a holistic education.
                    The laboratories are equipped with the latest tools and technologies, providing hands-on experience
                    in pharmaceutical analysis, formulation development, and pharmacology. Classrooms are designed for
                    interactive learning and equipped with visual aids. Arni School of Pharmacy aims to create a
                    conducive environment for students to excel academically and become competent pharmacists in the
                    healthcare industry.
                </p>
                <p><b>Scope </b> - A bachelor's degree in pharmacy can be used to work as a pharmacy technician in a
                    variety of
                    situations, including manufacturing, government healthcare positions, retail and hospital
                    pharmacies, and diploma programs in pharmacy (D. Pharmacy).
                </p>
                <ul>
                    <li>
                        A person with a diploma can help pharmacists with inventory management, drug delivery, and
                        compliance assurance.
                    </li>
                    <li> Graduates with a Bachelor of Pharmacy (B. Pharmacy) can specialize in clinical pharmacy,
                        pharmaceutical research, or industrial jobs like production, quality assurance, and regulatory
                        affairs. They can also become licensed pharmacists.
                    </li>
                    <li> Additionally, they can work in academia or as pharmaceutical consultants, advancing research,
                        education, and healthcare policy.
                    </li>
                </ul>
                <p><b>The ARNI School of Pharmacy would be your ideal parent on the journey towards the world of
                    medicine and healthcare. Join us to create a healthier, brighter future with us.
                </b></p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 ">
    <div class="container ">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">2</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">8</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">1</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Pharmacy</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">B.Pharmacy</td>
                        </tr>
                        <tr>
                            <td class="time">D.Pharmacy</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
